__webpack_require__.p = "https://hml.gestionminera.mp.gba.gob.ar/";